import React from 'react'

const Logout = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M2.83203 14.9154H19.7504M19.7504 14.9154L15.5208 11.29M19.7504 14.9154L15.5208 18.5408" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9375"></path>
<path d="M11.2925 8.87432C11.307 6.24593 11.4242 4.82236 12.3523 3.89427C13.4145 2.83203 15.1233 2.83203 18.5408 2.83203H19.7493C23.168 2.83203 24.8768 2.83203 25.939 3.89427C27 4.95529 27 6.66526 27 10.0828V19.7504C27 23.168 27 24.8779 25.939 25.939C24.8756 27.0012 23.168 27.0012 19.7493 27.0012H18.5408C15.1233 27.0012 13.4145 27.0012 12.3523 25.939C11.4242 25.0109 11.307 23.5873 11.2925 20.9589" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.9375"></path>
</svg>
    )
}

export default Logout
